import { useState, useEffect } from "react";
// import Lenis from "@studio-freight/lenis";
import Loader from "./components/loader/Loader";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import About from "./components/about/About";
import Trooh from "./components/trooh/Trooh";
import HHTH from "./components/hhth/HHTH";
import AGO from "./components/ago/AGO";
import Freelance from "./components/freelance/Freelance";
import Video from "./components/video/Video";
import Contact from "./components/contact/Contact";

import "./app.css";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fakeDataFetch = () => {
      setTimeout(() => {
        setIsLoading(false);
      }, 5500);
    };
    fakeDataFetch();
  }, []);

  // useEffect(() => {
  //   if (!isLoading) {
  //     const lenis = new Lenis({
  //       duration: 1.2,
  //       easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  //       smooth: true,
  //     });

  //     function raf(time) {
  //       lenis.raf(time);
  //       requestAnimationFrame(raf);
  //     }
  //     requestAnimationFrame(raf);

  //     // Fix scroll height if images/videos finish loading late
  //     const handleResize = () => lenis.resize();
  //     window.addEventListener("load", handleResize);
  //     window.addEventListener("resize", handleResize);

  //     return () => {
  //       window.removeEventListener("load", handleResize);
  //       window.removeEventListener("resize", handleResize);
  //       lenis.destroy();
  //     };
  //   }
  // }, [isLoading]); // Only runs when loading finishes

  return isLoading ? (
    <Loader />
  ) : (
    <div className="app">
      <Header />
      <div className="nav-parent">
        <Nav />
      </div>
      <div className="sections">
        <About />
        <Trooh />
        <HHTH />
        <AGO />
        <Freelance />
        <Video />
        <Contact />
      </div>
      <img
        src="img/landing-page-img.jpg"
        className="landing-img-mobile"
        alt="ago1"
      />
    </div>
  );
}

export default App;